import PipeLineService from '../../api/pipeline.service';

const state = {};

const getters = {};

const actions = {
	async getContacts({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await PipeLineService.getContacts(authToken);
		return response;
	},

	async getContactDetails({ rootState }, id) {
		const { authToken } = rootState.auth;
		const response = await PipeLineService.getContactDetailAsync(authToken, id);
		return response;
	},

	async getleadDetails({ rootState }, id) {
		const { authToken } = rootState.auth;
		const response = await PipeLineService.getLeadDetailAsync(authToken, id);
		return response;
	},

	async getLeads({ rootState }) {
		const { authToken } = rootState.auth;
		const response = await PipeLineService.getLeads(authToken);
		return response;
	},

	async addContact({ rootState }, payload) {
		const { authToken } = rootState.auth;
		const response = await PipeLineService.addContactAsync(authToken, payload);
		return response;
	},

	async addLead({ rootState }, payload) {
		const { authToken } = rootState.auth;
		const response = await PipeLineService.addLeadAsync(authToken, payload);
		return response;
	},

	async updateleadStatus({ rootState }, payload) {
		const { authToken } = rootState.auth;
		const response = await PipeLineService.updateleadStatusAsync(authToken, payload);
		return response;
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
